import { useRouter } from 'next/router'
import { Language } from 'types/language'
import { getUpperCaseLanguage, isValidLowercaseLanguage } from 'utils/format'
import { LanguageCase, UseGetLanguage } from './types'

export const useGetLanguage = ((languageCase: LanguageCase = 'lowercase') => {
  const { locale = '' } = useRouter()

  if (languageCase === 'uppercase') {
    return getUpperCaseLanguage(locale)
  }

  return isValidLowercaseLanguage(locale) ? locale : Language.DUTCH
}) as UseGetLanguage
